<script setup>
import { computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const number = defineModel('number', { type: String, default: '' });
// An explicit undefined default stops Vue casting a missing value to false
const screenSetting = defineModel('screen', {
  type: Boolean,
  default: undefined,
});

// On unless switched off, matching the server (menu options saved before the switch have no value)
const screen = computed({
  get: () => screenSetting.value !== false,
  set: value => {
    screenSetting.value = value;
  },
});
</script>

<template>
  <div class="flex flex-col gap-3">
    <Input
      v-model="number"
      :placeholder="$t('INBOX_MGMT.CALL_HANDLING.FORWARD.PLACEHOLDER')"
      :message="$t('INBOX_MGMT.CALL_HANDLING.FORWARD.HINT')"
    />
    <label class="flex items-start gap-2 text-label-small text-n-slate-11">
      <Switch v-model="screen" class="mt-0.5" />
      <span class="flex flex-col gap-0.5">
        <span class="text-n-slate-12">
          {{ $t('INBOX_MGMT.CALL_HANDLING.FORWARD.SCREEN') }}
        </span>
        {{ $t('INBOX_MGMT.CALL_HANDLING.FORWARD.SCREEN_HELP') }}
      </span>
    </label>
  </div>
</template>
